<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM HỌC SINH VÀO KỲ KIỂM TRA</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-6 pt-6 pb-0">
        <div class="field-label pb-4">Ảnh 3x4 của học sinh</div>
        <v-row class="d-flex flex-column pb-6" no-gutters>
          <div>
            <v-img width="120" height="160" :src="avatar" />
          </div>
        </v-row>
        <v-row class="my-0">
          <v-col class="py-0">
            <div class="field-label">Họ Tên học sinh</div>
            <div class="info-label mt-2 mb-6">
              {{ document.name || 'Chưa có thông tin' }}
            </div>
          </v-col>
          <v-col class="py-0" cols="12" xs="12" sm="12" md="6">
            <div class="field-label">Mã học sinh</div>
            <div class="info-label mt-2 mb-6">
              {{ document.code_short || 'Chưa có thông tin' }}
            </div>
          </v-col>
        </v-row>
        <v-row class="my-0">
          <v-col class="py-0" cols="12" xs="12" sm="12" md="6">
            <div class="field-label">Ngày tháng năm sinh</div>
            <div class="info-label mt-2 mb-6">
              {{ document.dob }}
            </div>
          </v-col>
          <v-col class="py-0" cols="12" xs="12" sm="12" md="6">
            <div class="field-label">Giới tính</div>
            <div class="info-label mt-2 mb-6">
              {{ getStudentGender }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    document: { type: Object, default: () => {} },
    state: Boolean,
    exam: String
  },
  computed: {
    getStudentGender() {
      switch (this.document.gender) {
        case 'male':
          return 'Nam'
        case 'female':
          return 'Nữ'
        case 'other':
          return 'Khác'
        default:
          return '-'
      }
    },
    avatar() {
      if (this.document.avatar) return `${this.document.avatar.url}`
      else return '/img/avatar.png'
    }
  },
  watch: {
    state(state) {
      this.dialog = state
    }
  },
  methods: {
    ...mapActions('studentExam', ['createStudentExam']),
    async submit() {
      this.$loading.active = true
      const data = {
        student: this.document._id,
        exam: this.exam,
        examCode: this.document.code_short,
        nameToNumber: this.document.nameToNumber,
        tagS: this.document.tags,
        status: 'notSeated'
      }
      const stuEx = await this.createStudentExam(data)
      if (stuEx) {
        this.$emit('refresh')
        this.close()
      } else {
        this.$alert.error('Lỗi tạo học sinh')
      }
      this.$loading.active = false
    },
    close() {
      this.$emit('closeDialog')
    }
  },
  components: {},
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>
.field-label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #797979;
  margin-bottom: 4px;
}
.section-label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #3e3e3c;
}
.info-label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #3e3e3c;
}
</style>
